<template>
  <FriedParagraph :size="ParagraphSize.Small" class="timestamp">
    <span class="date">{{ date }}</span>
    {{ t('at') }} {{ time }}
  </FriedParagraph>
</template>

<script lang="ts">
import { ParagraphSize } from '@getaccept/fried-tofu';
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    date: {
      type: String,
      default: '',
    },
    time: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { t } = useI18n();
    return {
      ParagraphSize,
      t,
    };
  },
});
</script>

<style lang="scss" scoped>
.timestamp {
  text-align: center;
  margin-bottom: var(--spacing-100);
  color: var(--text-gray);

  .date {
    font-weight: 600;
  }
}
</style>
